import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-ApplePay',
  standalone: true,
  templateUrl: '../../assets/ApplePay.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamApplePayIcon {}
